/**
 * Formats time in seconds to MM:SS or HH:MM:SS format
 *
 * @param seconds - Time in seconds
 * @returns Formatted time string
 *
 * @example
 * ```typescript
 * formatTime(90); // "1:30"
 * formatTime(3665); // "1:01:05"
 * formatTime(45); // "0:45"
 * ```
 */
const formatTime = (seconds: number): string => {
  if (!isFinite(seconds) || seconds < 0) {
    return "0:00";
  }

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hrs > 0) {
    return `${hrs}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }

  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export { formatTime };
